import { useEffect, useRef, type JSX } from "react";
import { createPortal } from "react-dom";

interface PortalProps {
    children?: JSX.Element;
    /**
     * The DOM element to attach the portal to. Defaults to the element with id 'portal-root'.
     */
    container?: Element | null;
}

const Portal = ({ children, container }: PortalProps) => {
    const elRef = useRef<HTMLDivElement | null>(null);

    if (!elRef.current) {
        elRef.current = document.createElement("div");
    }

    useEffect(() => {
        const portalRoot = container ?? document.getElementById("portal-root");
        if (!portalRoot) return;
        portalRoot.appendChild(elRef.current as Node);
        return () => {
            portalRoot.removeChild(elRef.current as Node);
        };
    }, [container]);

    return createPortal(children, elRef.current);
};

export default Portal;
